
import React, { Component } from "react";
import { Redirect } from 'react-router-dom';
import $ from 'jquery';
import { DatePicker } from 'antd';
import { Row, Col, Form, Button, Spinner, Alert } from "react-bootstrap";
import { FaLock, FaUser, FaEye, FaEnvelope, FaPhoneAlt, FaTransgender, FaUserMd, FaPlus, FaBookMedical } from "react-icons/fa";
import { Multiselect } from 'multiselect-react-dropdown';

import Crypt from '../lib/Crypt'
import OtpAuthModal from './OtpAuthModal';
import ErrorAlert from './ErrorAlert';
import 'antd/dist/antd.css';
import C from '../lib/Config';

const dateFormat = 'DD/MM/yyyy';

$(document).ready(function () {
    $('#selectBox').on('change', function () {
        if (this.value === 'addNew') {
            $("#addDegree").css("display", "block");
        } else {
            $("#addDegree").css("display", "none");
        }
    });
});
const loggingInAsList = [
    { key: Crypt.getUniqueKey('0'), id: 'DEFAULT', label: '- Logging in as -' },
    { key: Crypt.getUniqueKey('1'), id: '2', label: 'Doctor' },
    { key: Crypt.getUniqueKey('2'), id: '3', label: 'Hospital Staff' },
]

function passwordShow() {
    var x = document.getElementById("myInput");
    if (x.type === "password") {
      x.type = "text";
    } else {
      x.type = "password";
    }
}
export default class Register extends Component {
    constructor(props) {
        super(props)
        this.state = {
            firstName: '',
            lastName: '',
            username: '',
            password: '',
            confirmpassword: '',
            confirmPasswordVisible: false,
            countryCode: '',
            phoneNumber: '',
            dob: '',
            genderDto: {
                genderId: ''
            },
            userRoleDto: {
                roleId: ''
            },
            profDegreeDto: {
                profDegreeId: ''
            },
            associatedDocDto: {
                userId: '',
                firstName: '',
                lastName: ''
            },
            countryDTO: {
                countryId: ''
            },
            errors: {},
            signInPage: false,
            isShowAssociatedWIthDoctor: false,
            errorAlertshow: false,
            errorAlertclose: false,
            associatedDoctorDTOList: [],
            isDoctor: false,
            isTermsAndConditionsAgreed: false,
            countryArr: [],
            genderList: [],
            profDegreeList: [],
            associateDocList: [],
            profilePictureName: '',
            profilePictureData: '',
            generateOtpLoader: false,
            isOtpModalShown: false,
            otp: null
        }
        this.handleChange = this.handleChange.bind(this);
        this.onBlur = this._onBlur.bind(this);
    }
    componentDidMount() {
        this.countryMasterApiCall();
        this.genderMasterApiCall();
        this.profDegreeMasterApiCall();
        this.associatedDocMasterApiCall();
    }
    _onBlur(event) {
        if (event.target.name === 'email') {
            const email = event.target.value;
            if (email.trim() !== '') {
            return fetch(C.getUrl() + '/user/emailIdExists/' + event.target.value, {
                method: 'GET',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(res => res.json())
                .then(res => {
                    let obj = res;
                    let error = obj.subErrors;
                    if (error !== null) {
                        alert(error);
                        event.target.value = '';
                    }
                })
                .catch(err => console.error('Error fetching email:', err));
            }
        }
    }

    toggleConfirmPasswordVisibility = () => {
        this.setState(prevState => ({
          confirmPasswordVisible: !prevState.confirmPasswordVisible
        }));
      };

    handleChange(event) {
        const { isShowAssociatedWIthDoctor, associateDocList, countryArr, countryCode } = this.state;
        if (event.target.name === 'firstName') {
            this.setState({ firstName: event.target.value });
        }
        if (event.target.name === 'lastName') {
            this.setState({ lastName: event.target.value });
        }
        if (event.target.name === 'email') {
            this.setState({ username: event.target.value });
        }
        if (event.target.name === 'password') {
            this.setState({ password: event.target.value });
        }
        if (event.target.name === 'confirmpassword') {
            this.setState({ confirmpassword: event.target.value });
        }
        if (event.target.name === 'countryCode') {
            countryArr.map((item, index) => {
                if (item.id === event.target.value + '') {
                    //console.log('--> Country Code value : ' + item.phoneCountryCode);
                    this.setState({
                        countryCode: item.phoneCountryCode,
                        countryDTO: { countryId: item.id + '' }
                    });
                }
            });
        }
        if (event.target.name === 'phoneNumber') {
            this.setState({ phoneNumber: `${countryCode}${event.target.value}` });
        }
        if (event.target.name === 'dob') {
            this.setState({ dob: event.target.value });
        }
        if (event.target.name === 'gender') {
            this.setState({ genderDto: { genderId: event.target.value } });
        }
        if (event.target.name === 'userrole') {
            this.setState({
                userRoleDto: { roleId: event.target.value },
                isShowAssociatedWIthDoctor: (event.target.value === '3') ? true : false,
                isDoctor: (event.target.value === '2') ? true : false
            });
        }
        if (event.target.name === 'qualification') {
            this.setState({ profDegreeDto: { profDegreeId: event.target.value } });
        }
    }
    termsAndConditionHandler = () => {
        var checkBox = document.getElementById("check-terms");
        this.setState({ isTermsAndConditionsAgreed: checkBox.checked ? true : false });
    }
    nextButtonHandler = () => {
        var x = document.getElementById("professional-info");
        var y = document.getElementById("general-info");
        if (this.validateGeneralInfo()) {
            if (x.style.display === "none") {
                x.style.display = "block";
                y.style.display = "none";
            } else {
                x.style.display = "none";
                y.style.display = "block";
            }
        }
    }
    previousButtonHandler = () => {
        var x = document.getElementById("professional-info");
        var y = document.getElementById("general-info");
        if (y.style.display === "none") {
            y.style.display = "block";
            x.style.display = "none";
        } else {
            y.style.display = "none";
            x.style.display = "block";
        }
    }
    validateGeneralInfo = () => {
        let formIsValid = true;
        let errors = {};
        let state = this.state;
        if (state.firstName === "" || state.firstName.length <= 0) {
            errors["firstName"] = "Please enter first name";
            formIsValid = false;
        }
        if (state.lastName === "" || state.lastName.length <= 0) {
            errors["lastName"] = "Please enter last name";
            formIsValid = false;
        }
        if (state.username === "" || state.username.length <= 0) {
            errors["username"] = "Please enter a valid e-mail address";
            formIsValid = false;
        } else if (state.username !== "undefined") {
            let lastAtPos = state.username.lastIndexOf('@');
            let lastDotPos = state.username.lastIndexOf('.');

            if (!(lastAtPos < lastDotPos && lastAtPos > 0 && state.username.indexOf('@@') === -1 && lastDotPos > 2 && (state.username.length - lastDotPos) > 2)) {
                formIsValid = false;
                errors["username"] = "Please enter a valid e-mail address";
            }
        }
        if (state.password === "" || state.password.length <= 0) {
            errors["password"] = "Please enter password";
            formIsValid = false;
        }
        if (state.confirmpassword === "" || state.confirmpassword.length <= 0) {
            errors["confirmpassword"] = "Please confirm password";
            formIsValid = false;
        }
        // Check if passwords match
        if (state.password !== '' && state.confirmpassword !== "") {
            if (state.password !== state.confirmpassword) {
                errors["confirmpassword"] = "Passwords do not match";
                formIsValid = false;
            }
        }
        if (state.phoneNumber === "" || state.phoneNumber.length <= 0) {
            errors["phoneNumber"] = "Please enter phone number";
            formIsValid = false;
        }
        else {
            const phoneWithoutCountryCode = state.phoneNumber.replace(state.countryCode, '');
            const phoneRegex = /^\d{10}$/;

            if (!phoneRegex.test(phoneWithoutCountryCode)) {
                errors["phoneNumber"] = "Phone number must be exactly 10 digits";
                formIsValid = false;
            }
        }
        if (state.dob === "" || state.dob.length <= 0) {
            errors["dob"] = "Please enter date of birth";
            formIsValid = false;
        }
        this.setState({ errors: errors });
        return formIsValid;
    }
    validateProfessionalInfo = () => {
        const { isShowAssociatedWIthDoctor, isDoctor, profilePictureName, profilePictureData } = this.state;
        let formIsValid = true;
        let errors = {};
        let state = this.state;
        //console.log("state.genderDto.genderId " + state.genderDto.genderId);
        if (state.genderDto.genderId.length === "") {
            errors["gender"] = "Please select gender";
            formIsValid = false;
        }
        if (state.userRoleDto.roleId === "" || state.userRoleDto.roleId === "DEFAULT") {
            errors["userrole"] = "Please select login as";
            formIsValid = false;
        }
        if (isShowAssociatedWIthDoctor) {
            if (state.associatedDocDto.userId.length === "") {
                errors["associatedDoctor"] = "Please select associated doctor";
                formIsValid = false;
            }
        }
        if(isDoctor) {
            if (state.profDegreeDto.profDegreeId.length === "") {
                errors["qualification"] = "Please enter qualification";
                formIsValid = false;
            }
        }
        if (profilePictureName === '' && profilePictureData === '') {
            errors["profilePicture"] = "Please select a profile picture";
            formIsValid = false;
        }
        this.setState({ errors: errors });
        return formIsValid;
    }
    otpModalHandler = () => {
        const { isOtpModalShown } = this.state;
        this.setState({ isOtpModalShown: !isOtpModalShown });
    }
    generateOtpInputJson = () => {
        const { firstName, lastName, username } = this.state;
        let jsonData = new Object();
        jsonData['firstName'] = firstName;
        jsonData['lastName'] = lastName;
        jsonData['username'] = username;
        //console.log('--- INPUT JSON FOR GENERATE OTP : ' + JSON.stringify(jsonData))
        return jsonData;
    }
    generateOtpHandler = () => {
        const { isTermsAndConditionsAgreed } = this.state;
        let isThisValidForm = false;
        if (this.validateProfessionalInfo()) {
            if (!isTermsAndConditionsAgreed) {
                //console.log('--> Valid form but >> Terms and condition not checked')
                alert("Please indicate that you have read and agree to the Terms and Conditions");
                isThisValidForm = false;
            } else {
                console.log('--> Valid form')
                isThisValidForm = true;
            }
        }

        //console.log('--> USER REGISTRATION FORM DATA : ' + JSON.stringify(this.state));
        if (isThisValidForm) {
            this.setState({ generateOtpLoader: true })
            return fetch(C.getUrl() + '/user/addOrUpdate', {
                method: 'POST',
                mode: 'cors',
                body: JSON.stringify(this.generateOtpInputJson()),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then(res => res.json())
            .then(res => {
                let obj = res;
                let error = obj.subErrors;
                this.setState({ generateOtpLoader: false })
                if (error !== null && error !== "") {
                    alert(error)
                } else {
                    console.log('--- GENERATE OTP SUCCESS : ')
                    this.otpModalHandler();
                }
            })
            .catch(err => {
                console.log("Error : " + err);
                this.setState({ generateOtpLoader: false, errorAlertshow: true });
                setTimeout(() => {
                    this.setState({ errorAlertshow: false })
                }, 3000)
            });
        }
    }

    countryMasterApiCall = async () => {
        fetch(C.getUrl() + '/countryMaster/getallCountries')
            .then(res => res.json())
            .then(res => {
                let data = JSON.parse(res.message);
                var arr = [];
                data.map((item, index) => {
                    let jsonList = new Object();
                    let ccode = item.phoneContryCode + '';
                    let value = ccode.replace('+', '').trim();
                    jsonList['key'] = Crypt.getUniqueKey(index);
                    jsonList['id'] = item.countryId + '';
                    jsonList['label'] = `${item.countryCode} ${item.phoneContryCode}`;
                    jsonList['phoneCountryCode'] = `${value}`;
                    arr.push(jsonList);
                });
                console.table(arr)
                this.setState({
                    countryArr: arr,
                    countryCode: arr[0].phoneCountryCode,
                    countryDTO: { countryId: arr[0].id + '' }
                });
            })
            .catch(err => {
                console.log("Error : " + err);
                this.setState({ errorAlertshow: true });
                setTimeout(() => {
                    this.setState({ errorAlertshow: false })
                }, 3000)
            });
    }

    genderMasterApiCall = async () => {
        fetch(C.getUrl() + '/genderMaster/getAllGenders')
            .then(res => res.json())
            .then(res => {
                //console.log('--> GENDER MASTER STATUS : ' + res.status)
                let data = JSON.parse(res.message);
                //console.log('--> GENDER MASTER - MESSAGE DATA: ' + JSON.stringify(data));
                if (data !== null) {
                    let genderData = [{ key: Crypt.getUniqueKey('0'), id: 'DEFAULT', label: '- Select Gender -' }];
                    data.map((item, index) => {
                        let jsonList = new Object();
                        jsonList['key'] = Crypt.getUniqueKey(index);
                        jsonList['id'] = item.genderId + '';
                        jsonList['label'] = item.genderName;
                        genderData.push(jsonList);
                    });
                    console.table(genderData)
                    this.setState({ genderList: genderData });
                }

            })
            .catch(err => {
                console.log("Error : " + err);
                this.setState({ errorAlertshow: true });
                setTimeout(() => {
                    this.setState({ errorAlertshow: false })
                }, 3000)
            });
    }

    profDegreeMasterApiCall = async () => {
        fetch(C.getUrl() + '/profDegreeMaster/getAllProfDegreeMasters')
            .then(res => res.json())
            .then(res => {
                //console.log('--> PROF DEGREE MASTER STATUS : ' + res.status)
                let data = JSON.parse(res.message);
                //console.log('--> PROF DEGREE MASTER - MESSAGE DATA: ' + JSON.stringify(data));
                if (data !== null) {
                    let profDegreeData = [{ key: Crypt.getUniqueKey('0'), id: 'DEFAULT', label: '- Select Qualification -' },];
                    data.map((item, index) => {
                        let jsonList = new Object();
                        jsonList['key'] = Crypt.getUniqueKey(index);
                        jsonList['id'] = item.profDegreeId + '';
                        jsonList['label'] = item.profDegreeName;
                        profDegreeData.push(jsonList);
                    });
                    console.table(profDegreeData)
                    this.setState({ profDegreeList: profDegreeData });
                }
            })
            .catch(err => {
                console.log("Error : " + err);
                this.setState({ errorAlertshow: true });
                setTimeout(() => {
                    this.setState({ errorAlertshow: false })
                }, 3000)
            });
    }

    associatedDocMasterApiCall = async () => {
        fetch(C.getUrl() + '/user/getallActiveDoctors')
            .then(res => res.json())
            .then(res => {
                //console.log('--> ASSOCIATED DOC MASTER STATUS : ' + res.status)
                let data = JSON.parse(res.message);
                //console.log('--> ASSOCIATED DOC MASTER - MESSAGE DATA: ' + JSON.stringify(data));
                if (data !== null) {
                    let associatedDoc = [{
                        id: 'DEFAULT',
                        firstName: '',
                        lastName: '',
                        name: '- Select Associated Doctor -',
                    },];
                    data.map((item, index) => {
                        let jsonList = new Object();
                        jsonList['id'] = item.userId + '';
                        jsonList['firstName'] = `${item.firstName}`;
                        jsonList['lastName'] = `${item.lastName}`;
                        jsonList['name'] = `${item.firstName} ${item.lastName}`;
                        associatedDoc.push(jsonList);
                    });
                    console.table(associatedDoc)
                    this.setState({ associateDocList: associatedDoc });
                }
            })
            .catch(err => {
                console.log("Error : " + err);
                this.setState({ errorAlertshow: true });
                setTimeout(() => {
                    this.setState({ errorAlertshow: false })
                }, 3000)
            });
    }
    profilePicHandler = (e) => {
        //console.log('--> PROFILE PIC :: ' + e.target.files[0].name);
        //console.log('--> PROFILE PIC [file type] :: ' + e.target.files[0].type);
        let file = e.target.files[0];
        let fileType = e.target.files[0].type;
        let validFileType = this.isValidFileType(fileType);
        if (file && validFileType) {
            const reader = new FileReader();
            reader.onload = (readerEvent) => {
                this.fileReaderHandler(readerEvent, fileType);
            };
            reader.readAsBinaryString(file);
            this.setState({
                profilePictureName: e.target.files[0].name
            });
        }
    }
    fileReaderHandler = (readerEvent, fileType) => {
        let binaryString = readerEvent.target.result;
        let imageData = 'data:image/' + fileType.split('/')[1] + ';base64,' + btoa(binaryString);
        //console.log('--> BASE64 DATA : ' + imageData);
        this.setState({
            profilePictureData: imageData
        });
    }
    isValidFileType = (type) => {
        switch (type) {
            case 'image/png':
                return true;

            case 'image/jpeg':
                return true;

            case 'image/jpg':
                return true;

            default:
                return false;
        }
    }
    setDOB(date) {
        this.setState({ dob: date })
    }

    setAssociatedDocList = (value) => {
        //console.log('--> ' + JSON.stringify(value))
        this.setState({ associatedDoctorDTOList: value })
    }

    toggleVisibility = (field) => {
        this.setState(prevState => ({
          [field]: !prevState[field]
        }));
      };
      
    render() {
        const { isShowAssociatedWIthDoctor, isDoctor, isOtpModalShown, signInPage, countryArr, genderList, profDegreeList, associateDocList,isPasswordVisible, isConfirmPasswordVisible, confirmPasswordVisible, errors } = this.state;
        if (signInPage) {
            return <Redirect to='sign-in' />
        }

        return (
            <div id="page-login" className='h100 form-body'>
                <Row>
                    <Col lg='7' className="pl-0 pr-0"><div className="bg-image"></div></Col>
                    <Col lg='5' className="pl-0 pr-0">
                        <div className="form-holder">
                            <div className="form-content">
                                <div className="form-items" style={{ maxWidth: "420px" }}>
                                    <h3 className="text-center w-100">SIGN UP</h3>
                                    <Form>
                                        <div id="general-info">
                                            <Row className="mt-2">
                                                <Col lg='6'>
                                                    <Form.Group className='input-group'>
                                                        <span className="input-group-addon"><FaUser className='' /></span>
                                                        <Form.Control type='text' placeholder='First Name' name='firstName' onChange={this.handleChange} />
                                                        <div className="invalid-feedback">{this.state.errors["firstName"]}</div>
                                                    </Form.Group>
                                                </Col>
                                                <Col lg='6'>
                                                    <Form.Group className='input-group'>
                                                        <span className="input-group-addon"><FaUser className='' /></span>
                                                        <Form.Control type='text' placeholder='Last Name' name='lastName' onChange={this.handleChange} />
                                                        <div className="invalid-feedback">{this.state.errors["lastName"]}</div>
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col lg='12'>
                                                    <Form.Group className='input-group'>
                                                        <span className="input-group-addon"><FaEnvelope className='' /></span>
                                                        <Form.Control type='email' placeholder='Email Address' name='email' onBlur={this._onBlur} onChange={this.handleChange} />
                                                        <div className="invalid-feedback">{this.state.errors["username"]}</div>
                                                    </Form.Group>
                                                </Col>
                                                <Col lg='6'>
                                                    <Form.Group className='input-group'>
                                                        <span className="input-group-addon"><FaLock className='' /></span>
                                                        <Form.Control type='password' id="myInput" placeholder='Password' name='password' onChange={this.handleChange} />
                                                        <span className="input-group-addon" style={{ backgroundColor: "#ffff" }}><FaEye className='' onClick={passwordShow} /></span>
                                                        <div className="invalid-feedback">{this.state.errors["password"]}</div>
                                                    </Form.Group>
                                                </Col>
                                                <Col lg='6'>
                                                    {/* <Form.Group className='input-group'>
                                                        <span className="input-group-addon"><FaLock className='' /></span>
                                                        <Form.Control type='password' id="" name="confirmpassword" placeholder='Confirm Password' onChange={this.handleChange} />
                                                        <span className="input-group-addon" style={{ backgroundColor: "#ffff" }}><FaEye className='' onClick={confirmpassword} /></span>
                                                        <div className="invalid-feedback">{this.state.errors["confirmpassword"]}</div>
                                                    </Form.Group> */}
                                                    <Form.Group className='input-group'>
                                                        <span className="input-group-addon"><FaLock /></span>
                                                        <Form.Control 
                                                            type={confirmPasswordVisible ? 'text' : 'password'} 
                                                            name="confirmpassword" 
                                                            placeholder='Confirm Password' 
                                                            onChange={this.handleChange} 
                                                        />
                                                        <span className="input-group-addon" style={{ backgroundColor: "#ffff" }}>
                                                            <FaEye onClick={this.toggleConfirmPasswordVisibility} />
                                                        </span>
                                                        <div className="invalid-feedback">{errors["confirmpassword"]}</div>
                                                        </Form.Group>
                                                </Col>
                                                <Col lg='12'>
                                                    <Form.Group className='input-group'>
                                                        <span className="input-group-addon"><FaPhoneAlt className='' /></span>
                                                        <Form.Control as="select" id="" name='countryCode' style={{ maxWidth: "105px" }} onChange={this.handleChange}>
                                                            {
                                                                countryArr.map((item, i) => {
                                                                    return (
                                                                        <option key={item.key} value={item.id}>{`${item.label}`}</option>
                                                                    );
                                                                })
                                                            }
                                                        </Form.Control>
                                                        <Form.Control type='number' maxLength='10' className="ml-2" placeholder='Contact Number' name='phoneNumber' onChange={this.handleChange} />
                                                        <div className="invalid-feedback">{this.state.errors["phoneNumber"]}</div>
                                                    </Form.Group>
                                                </Col>
                                                <Col lg='12'>
                                                    <Form.Group className='input-group'>
                                                        <DatePicker
                                                            onChange={date => this.setDOB(date)}
                                                            placeholder="Date of Birth"
                                                            format={dateFormat} className="full-width" />
                                                        <div className="invalid-feedback">{this.state.errors["dob"]}</div>
                                                    </Form.Group>
                                                </Col>
                                                <Col lg='12'>
                                                    <div className="form-button text-center mt-2">
                                                        <Button className="btn btn-info" type='button' onClick={() => this.nextButtonHandler()}>Next</Button>
                                                    </div>
                                                </Col>
                                                <Col lg='12'>
                                                    <div className="other-links">
                                                        <div className="form-button text-center login-link mb-3 mt-3">
                                                            Already have an account? <a href="#/">Login</a>
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                        <div id="professional-info" style={{ display: "none" }}>
                                            <Row className="mt-4">
                                                <Col lg='6'>
                                                    <Form.Group className='input-group'>
                                                        <span className="input-group-addon"><FaTransgender className='' /></span>
                                                        <Form.Control as="select" id="" name='gender' onChange={this.handleChange}>
                                                            {
                                                                genderList.map((item, i) => {
                                                                    return (
                                                                        <option key={item.key} value={item.id}>{`${item.label}`}</option>
                                                                    );
                                                                })
                                                            }
                                                        </Form.Control>
                                                        <div className="invalid-feedback">{this.state.errors["gender"]}</div>
                                                    </Form.Group>
                                                </Col>
                                                <Col lg='6'>
                                                    <Form.Group className='input-group'>
                                                        <span className="input-group-addon"><FaUserMd className='' /></span>
                                                        <Form.Control as="select" id="" name='userrole' onChange={this.handleChange}>
                                                            {
                                                                loggingInAsList.map((item, i) => {
                                                                    return (
                                                                        <option key={item.key} value={item.id}>{`${item.label}`}</option>
                                                                    );
                                                                })
                                                            }
                                                        </Form.Control>
                                                        <div className="invalid-feedback">{this.state.errors["userrole"]}</div>
                                                    </Form.Group>
                                                </Col>
                                                {
                                                    (isShowAssociatedWIthDoctor) ?
                                                        <Col lg='12'>
                                                            <Form.Group className='input-group mb-6 customMultiselect'>
                                                                <span className="input-group-addon"><FaUserMd className='' /></span>
                                                                <Multiselect
                                                                    id='associatedDoc'
                                                                    options={associateDocList}
                                                                    onSelect={(value) => this.setAssociatedDocList(value)}
                                                                    onRemove={(value) => this.setAssociatedDocList(value)}
                                                                    placeholder='- Select Associated Doctor -'
                                                                    displayValue="name" />
                                                            </Form.Group>
                                                        </Col> :
                                                    null
                                                }
                                                {
                                                    (isDoctor) ?
                                                        <Col lg='12'>
                                                            <Form.Group className='input-group'>
                                                                <span className="input-group-addon"><FaBookMedical className='' /></span>
                                                                <Form.Control as="select" id="selectBox" name='qualification' onChange={this.handleChange}>
                                                                    {
                                                                        profDegreeList.map((item, i) => {
                                                                            return (
                                                                                <option key={item.key} value={item.id}>{`${item.label}`}</option>
                                                                            );
                                                                        })
                                                                    }
                                                                </Form.Control>
                                                                <div className="invalid-feedback">{this.state.errors["qualification"]}</div>
                                                            </Form.Group>
                                                        </Col> :
                                                        null
                                                }
                                                <Col lg='12' id="addDegree" style={{ display: "none" }}>
                                                    <Form.Group className='input-group'>
                                                        <span className="input-group-addon"><FaPlus className='' /></span>
                                                        <Form.Control type='text' id="" placeholder='If other, specify' />
                                                        <div className="invalid-feedback"></div>
                                                    </Form.Group>
                                                </Col>
                                                <Col lg='12'>
                                                    <Form.Group className='input-group mt-0 mb-2'>
                                                        <Form.File
                                                            type="file"
                                                            className="p-0"
                                                            id="inputGroupFile01"
                                                            style={{ width: "100%" }}
                                                            label="Upload Profile Pic"
                                                            onChange={(e) => this.profilePicHandler(e)}
                                                        />
                                                        <div className="invalid-feedback">{this.state.errors["profilePicture"]}</div>
                                                    </Form.Group>
                                                </Col>
                                                <Col lg='12' className="text-left mt-1 mb-3">
                                                    <input type="checkbox" id="check-terms" value="" style={{ width: "5%" }} onClick={() => this.termsAndConditionHandler()} />
                                                    <span><p className="form-button ml-2" style={{ display: "inline" }}>I agree to the <a href="" className="text">Terms and Conditions</a></p></span>
                                                </Col>
                                                <Col lg='12'>
                                                    <div className="form-button text-center">
                                                        <Button className="btn btn-info mr-2" type='button' onClick={() => this.previousButtonHandler()}>Previous</Button>
                                                        <Button className="btn btn-info" type='button' onClick={() => this.generateOtpHandler()}>
                                                            {this.state.generateOtpLoader && (
                                                                <Spinner className='mr-3' animation='border' size='1.5rem' />
                                                            )}
                                                            Generate OTP
                                                        </Button>
                                                    </div>
                                                </Col>
                                                <Col lg='12'>
                                                    <div className="other-links">
                                                        <div className="form-button text-center login-link mb-3 mt-3">
                                                            Already have an account? <a href="#/">Login</a>
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Form>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
                {<OtpAuthModal data={this.state} show={isOtpModalShown} closeModal={() => this.otpModalHandler()} redirect={(value) => this.setState({ signInPage: value })} />}
                <ErrorAlert show={this.state.errorAlertshow} alertBody={'Something went wrong. Please try again'}/>
            </div>
        );
    }
}